var course = {
    rateList : function(publicationId, partnerId, page){
        $('#idDivRate').find(".more-answer").find("a").append("<i class='ico-loading'></i>");
        $.ajax({
            url : '/es/course/rate', 
            type : 'POST',
            dataType : 'json',
            data : {publicationId: publicationId, page: page, partnerId : partnerId},
            success : function(data) {
                if(data.success) {
                    if(data.partnerId == 1) {
                        $('#idDivRate').find(".more-answer").remove();
                        $('#idDivRate').append('<div class="slider-comment slider">'+data.html+'</div>');
                        //custom.sliderRecommend();
                    } else {
                        $('#idDivRate').find(".more-answer").remove();
                        $('#idDivRate').append(data.html);
                    }
                } else {
                    $(elem).removeClass("btn-disable");
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: data.message,
                    });
                }
            }  
        });
    },
    getSidebarClassRoom : function(dataPublication){
                                            
        var loading = '<div class="clear-fix tab-mod-mat">'+
        '<ul class="nav" role="tablist">'+
        '<li class="nav-item">'+
        '<a class="nav-link active" id="modulos-tab" data-toggle="tab" href="#tabModulo" role="tab" aria-controls="tabModulos" aria-selected="true">Módulos</a>'+
        '</li>'+
        '<li class="nav-item">'+
        '<a class="nav-link" id="materiales-tab" data-toggle="tab" href="#tabMateriales" role="tab" aria-controls="tabMateriales" aria-selected="false">Materiales'+
        '</a>'+
        '</li>'+
        '</ul> </div>';
        $('#idSidebar').html(loading);
        $.ajax({
            url : '/es/class-room/sidebar', 
            type : 'POST',
            dataType : 'json',
            data : dataPublication,
            beforeSend: function() {
                $('#idSidebar').html('<p>Cargando...</p>');
             },
            success : function(data) {
                if(data.success) {
                    $('#idSidebar').html(data.html);
                } else {
                    $(elem).removeClass("btn-disable");
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: data.message,
                    });
                }
            }  
        });
    },
    sendShare: function(publicationId)
    {
        $.ajax({
            url : '/es/course/redirect-share', 
            type : 'POST',
            dataType : 'json',
            data : {publicationId:publicationId},
            success : function(data) {
                if(data.success) {
                    location.href = data.redirect;
                } else {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: data.message,
                    });
                }
            }  
        });
    }
};
